import axios from 'axios';
import { API_URL, axiosConfig } from '../../app/api.js';

const withCredentials = { ...axiosConfig, withCredentials: true };

/**
 * @param {{ period: 'day'|'week'|'month'|'all' }} params
 */
export const getPartnerOverview = (params) =>
    axios.get(`${API_URL}/partner/overview`, { ...withCredentials, params }).then((r) => r.data);
